import Vue from 'vue'
import { clone } from 'ramda'
//import equal from 'fast-deep-equal'

export default {
    name: 'UserDialogThingAssignmentTabComponent',
    components: {
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules:{
            type: Object,
            required: true
        },
        validForm:{
            type: Boolean,
            required: true
        },
        resetFormValidation:{
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,
        // search del treeview
        search: null,
        // elementos seleccionados
        selected: [],
        // últimos elementos seleccionados clonados (para evitar recursividad infinita en la función selectedChanged)
        lastSelectedCloned: null,
        // cuando se ejecuta la validación de elementos seleccionados, activo un spinner
        loading: false
    }),
    computed: {
    },
    created () {
    },
    mounted () {
        this.initialize()
    },
    methods: {
        /**
         * Obtiene la estructura anidada de empresas -> grupos -> equipos
         */
        initialize () {
            // expando el treeview
            const that = this
            Vue.nextTick(function () {
                that.expandCollapse(true)
            })
        },

        /**
         * Expande / colapsa el árbol
         * @param {*} value
         */
        expandCollapse (value) {
            this.$refs.thingAssignmentTreeview.updateAll(value)
        },
        /**
         * Cuando cambian los nodos seleccionados, ejecuto una función para eliminar de la selección
         * otros nodos que no corresponden:
         * - Cuando selecciono un hijo, el padre no debe estar seleccionado;
         * - Cuando selecciono un padre, los hijos no deben estar seleccionados.
         * De esta forma, no hay datos redundantes, por ejemplo, que una empresa esté en el arreglo userEnterprises
         * y todas las cosas estén en el arreglo userThings
         */
        getSelectionState(item) {
            const isSelected = this.selected.some(sel => sel.id === item.id)

            // Si no tiene hijos
            if (!item.children || item.children.length === 0) {
            return isSelected ? 'total' : 'none'
            }

            // Verificar hijos seleccionados
            const hijosSeleccionados = item.children.filter(child =>
            this.selected.some(sel => sel.id === child.id)
            ).length

            if (isSelected) return 'total'
            if (hijosSeleccionados > 0) return 'partial'
            return 'none'
        },

        selectedChanged(newSelected) {
            this.selected = newSelected
            const selectionResult = []
            const recorrer = (items) => {
            items.forEach(item => {
                if (this.getSelectionState(item) === 'total') {
                selectionResult.push(item)
                } else if (item.children && item.children.length) {
                recorrer(item.children)
                }
            })
            }
            recorrer(this.model.data)
            this.model.result.cleanAndUpdate(selectionResult)
        },

    },
    watch: {
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm (newVal, oldVal) {
            if (newVal!==oldVal) {
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal) {
                if (this.$refs.userDialogThingAssignmentTabForm) {
                    this.$refs.userDialogThingAssignmentTabForm.resetValidation()
                }
            }
        },
        /**
         * Búsqueda en el treeview de equipos asignados
         * @param {*} newVal
         */
        search (newVal) {
            if (newVal) {
                this.$refs.thingAssignmentTreeview.updateAll(true)
            }
        },
        /**
         * No asigno directamente los objetos seleccionados, para controlar cuando se modifican
         * las empresas seleccionadas
         */
        'model.selectedData':{
            deep: true,
            immediate: true,
            handler: function (newSelectedData) {
                this.selected = clone(newSelectedData)
                this.lastSelectedCloned = clone(this.selected)
            }
        },

    }
}
